/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';

const useStickyAtcExperiment = ({
    isEnabled,
    shouldTrackImpression = true,
}) => {
    const dispatch = useDispatch();
    const brand = useSelector(getBrand);
    const { loading, data } = useSalesforcePersonalizedContentQuery({
        queryName: 'stickyAtc',
        interactionName: `${brand?.domain || '1800flowers'} - mobile - pdp - sticky atc - v2`,
        featureFlag: isEnabled,
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    const stickyAtcUserGroup = data?.contentSF?.campaign?.campaignResponses?.[0]?.payload?.userGroup;
    const hasStickyAtcResponse = typeof stickyAtcUserGroup !== 'undefined';
    const isStickyAtcVariant = stickyAtcUserGroup?.toLowerCase?.() === 'test';
    const stickyAtcCampaignId = data?.contentSF?.campaign?.campaignResponses?.[0]?.campaignId;
    const stickyAtcExperimentReady = !isEnabled || !loading;

    let stickyAtcExperimentLabel = 'Control';
    if (isEnabled && (!hasStickyAtcResponse || isStickyAtcVariant)) {
        stickyAtcExperimentLabel = 'Variant';
    }

    const stickyAtcEnabled = isEnabled
        && stickyAtcExperimentReady
        && (hasStickyAtcResponse ? isStickyAtcVariant : true);

    useEffect(() => {
        if (
            !isEnabled
            || !shouldTrackImpression
            || !stickyAtcExperimentReady
            || !hasStickyAtcResponse
            || !stickyAtcCampaignId
            || typeof window === 'undefined'
            || window.wuStickyATCEventFired
        ) {
            return undefined;
        }

        dispatch(trackEvent({
            eventCategory: 'Experiment',
            eventAction: 'Sticky ATC',
            eventLabel: stickyAtcExperimentLabel,
            feature_detail: stickyAtcExperimentLabel,
            feature_element: 'Sticky ATC',
            feature_category: 'Experiment',
            experiment_id: stickyAtcCampaignId,
        }));
        window.wuStickyATCEventFired = true;

        return undefined;
    }, [dispatch, hasStickyAtcResponse, isEnabled, shouldTrackImpression, stickyAtcCampaignId, stickyAtcExperimentLabel, stickyAtcExperimentReady]);

    return {
        stickyAtcEnabled,
        stickyAtcExperimentLabel,
        stickyAtcExperimentReady,
        salesforceResponse: data?.contentSF,
    };
};

export default useStickyAtcExperiment;
